exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-container[data-v-52a7792e]{width:100%;max-width:480px;margin:0 auto}@media screen and (max-width:600px){.field-container[data-v-52a7792e]{display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}}.field-container .field[data-v-52a7792e]{background-repeat:no-repeat;position:relative}", ""]);

// exports
